import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useSSR } from "react-i18next";
import { LocationIcon, TickIcon } from "../../Utils/SVGs";

const LocationButton = ({ phoneNumber, send, onLocationRetrieved }) => {
  const [btnTxt, setBtnTxt] = useState();
  const [loading, setLoading] = useState(false);
  const handleSendLocation = () => {
    setLoading(true);
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const locationUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

          if (send) {
            // Send location via WhatsApp
            position.coords && setLoading(false);
            const whatsappUrl = `https://wa.me/${phoneNumber}?text=My%20location%20is:%20${encodeURIComponent(
              locationUrl
            )}`;
            window.open(whatsappUrl, "_self");
          } else if (onLocationRetrieved) {
            // Return location through callback
            onLocationRetrieved({ latitude, longitude });
            position.coords && setLoading(false);
            position.coords && setBtnTxt(TickIcon("white", 25));
          }
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Unable to retrieve your location.");
          setLoading(false);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  return (
    <Button
      variant={btnTxt ? "success" : "primary"}
      onClick={handleSendLocation}
    >
      {loading
        ? "Loading"
        : btnTxt
        ? btnTxt
        : send
        ? "Send My Location"
        : LocationIcon("white", 25)}
      {/* {send ? "Send My Location" : "Get Location"} */}
    </Button>
  );
};

export default LocationButton;

// example on how to use in parent directory
//---------------------------------------------
const handleLocationRetrieved = ({ latitude, longitude }) => {
  console.log("Location received:", latitude, longitude);
  // You can use the location data as needed here
};

<div>
  {/* Example for sending location via WhatsApp */}
  <LocationButton phoneNumber="+201110115999" send={true} />

  {/* Example for getting location without sending */}
  <LocationButton send={false} onLocationRetrieved={handleLocationRetrieved} />
</div>;
